export const WHEEL_ROW_HEIGHT = 36;
export const WHEEL_VISIBLE_ROWS = 7;
export const WHEEL_PADDING_ROWS = Math.floor(WHEEL_VISIBLE_ROWS / 2);
export const WHEEL_VIEWPORT_HEIGHT = WHEEL_ROW_HEIGHT * WHEEL_VISIBLE_ROWS;
